export default {
    linkList : {
        "operationPolicy": "นโยบายการดำเนินงาน",
        "communityPolicy": "นโยบายชุมชน",
        "youthProtectionPolicy": "นโยบายการคุ้มครองเยาวชน",
        "declarationOfSafety": "ประกาศทางการเกี่ยวกับความปลอดภัยและความไว้วางใจ",
        "cookiePolicy": "นโยบายคุกกี้",
        "customerSupport": "ศูนย์ช่วยเหลือลูกค้า",
        "guaranteeOfRights": "การรับรองสิทธิ์ของข้อมูลส่วนสำคัญ",
        "privacyPolicy": "นโยบายการจัดการข้อมูลส่วนตัว",
        "termsOfService": "ข้อตกลงในการใช้บริการ",
        "companyLink": "แนะนำบริษัท",
        "doNotSell": "Do Not Sell My Personal Information",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
    },
    footerWords:{
        "gameRelatedLaw": "สัญลักษณ์เพิ่มเติมตามกฎหมายที่เกี่ยวข้องกับเกม",
        "brandInformation": "ข้อมูลบริษัท",
        "copyright": "copyright",
        "channelingInfo": "บริษัท NCSOFT จำกัด (มหาชน) เป็นบริษัทกลางการผลิตและจัดจำหน่ายเกมภายใน plaync ไม่ใช่เป็นเจ้าตัวการผลิตและจัดจำหน่ายเกม<br>หน้าที่และความรับผิดชอบทั้งหมดที่เกี่ยวข้องกับการผลิตและจัดจำหน่าย จะอยู่ที่เจ้าตัวเกมแต่ละราย เราจะไม่รับผิดชอบต่อปัญหาใดๆ ที่เกิดขึ้นเกี่ยวกับเรื่องนี้"
    },
    infoCS:{
        "businessInformation": "ตรวจสอบข้อมูลนักธุรกิจ",
        "infoAddress": "MR. KIM TAEK-JIN ประธานบริหารบริษัท NCSOFT จำกัด (มหาชน) เลขทะเบียนนิติบุคคล: 144-85-04244 หมายเลขธุรกิจออนไลน์: เลขที่ 2013-Gyeonggi-Seongnam-1268",
        "infoEmail": "อีเมล",
        "mobile": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1566-7004 โทรสาร: +82-2-2186-3499",
        "pc": "",
        "other": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1600-0020 (เกม PC), +82-1566-7004 (เกมมือถือ) โทรสาร: +82-2-2186-3550 (เกม PC), +82-2-2186-3499 (เกมมือถือ)",
        "none": '',
        
        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(เกม PC)/MobileCS@ncsoft.com/(เกมมือถือ)",
        "infoEmail-none": "",
    },
    infoJP:{
        "jpReleaseDayValue_LW": "4 พฤศจิกายน 2564",
        "jpReleaseDay": "วันที่เปิดให้บริการ",
        "jpDevelopedBy": "ฝ่ายพัฒนา/ฝ่ายบริหาร",
        "jpOs": "การตอบสนอง OS",
        "jpPriceValue": "เล่นฟรี (มีการซื้อในแอป)",
        "jpPrice": "ราคา",
        "jpGenre": "ประเภท",
        "jpTitle": "ชื่อเรื่อง",
    },
    "country": {
        "HK": "ฮ่องกง",
        "PH": "ฟิลิปปินส์",
        "TH": "ไทย",
        "QA": "กาตาร์",
        "JP": "ญี่ปุ่น",
        "ID": "อินโดนีเซีย",
        "AE": "สหรัฐอาหรับเอมิเรตส์",
        "SG": "สิงคโปร์",
        "SA": "ซาอุดิอาระเบีย",
        "MY": "มาเลเซีย",
        "RU": "รัสเซีย",
        "TW": "ไต้หวัน",
        "KR": "เกาหลีใต้",
        "UA": "ยูเครน",
        "BY": "เบลารุส",
        "LT": "ลิทัวเนีย",
        "PL": "โปแลนด์",
        "GR": "กรีซ",
        "IL": "อิสราเอล",
        "KW": "คูเวต",
        "AT": "ออสเตรีย",
        "US": "สหรัฐอเมริกา",
        "CA": "แคนาดา",
        "DE": "เยอรมนี",
        "GB": "อังกฤษ",
        "FR": "ฝรั่งเศษ",
        "BR": "บราซิล",
        "IT": "อิตาลี",
        "ES": "สเปน",
        "CL": "ชิลี",
        "NO": "นอร์เวย์",
        "SE": "สวีเดน",
        "IE": "ไอร์แลนด์",
        "PT": "โปรตุเกส",
        "FI": "ฟินแลนด์",
        "DK": "เดนมาร์ก",
        "CH": "สวิตเซอร์แลนด์",
        "AR": "อาร์เจนตินา",
        "PE": "เปรู",
        "MX": "แม็กซิโก",
        "KZ": "คาซัคสถาน",
        "UZ": "อุซเบกิสถาน",
        "AZ": "อาเซอร์ไบจาน",
        "GE": "จอร์เจีย",
        "MD": "มอลโดวา",
        "AM": "อาร์เมเนีย",
        "NC": "Global"
    }
};